export const getResponseHeader = (response, header: string) => {
  const value = response.headers.has(header)
    ? (response.headers.get(header) as string)
    : null;
  return value;
};
